import { Link } from "react-router-dom";
import GetProjects from "../firebase/fetchDB";

const PortofolioProject = ({ category }) => {
  const { projects, isPending } = GetProjects();
  return (
    <div className="portofolio-projects">
      {isPending && <h1>LOADING...</h1>}
      {projects
        .map((project, i) => (
          <div className="portofolio-project" key={i}>
            <h2 className="portofolio-project-title">{project.title}</h2>
            <h3>{project.shortDesc}</h3>
            <Link to={`/projects/${i}`}>Click to find out more</Link>
          </div>
        ))}
    </div>
  );
};

export default PortofolioProject;
